import { z } from 'zod'
import { fileUpload } from '~/services/api/contracts/fileUpload'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { StoreImageTypeSchema, StoreUpdateImageRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const IMAGE = { mimes: ['jpeg', 'jpg', 'png', 'webp'], maxKb: 5120 } as const

// StoreImageRequest::prepareForValidation
const normalize = fieldNormalizer({
  enums: [{ field: 'type', options: StoreImageTypeSchema.options }]
})

const schema = StoreUpdateImageRequestSchema.extend({
  image: fileUpload(IMAGE)
}).strict()

export const StoreUpdateImage = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema)
